export type LocalStorageKey = 'jwtAccessToken';

export const localStorageSave = <T>(key: LocalStorageKey, data: T): void => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const localStorageGet = <T>(key: LocalStorageKey): T | null => {
  const data = localStorage.getItem(key);
  return data && JSON.parse(data);
};

export const localStorageRemove = (key: LocalStorageKey): void => {
  localStorage.removeItem(key);
};
